import { getCategoriesDatasource } from '@monoimin/datasources';

import { getAppConfigSlug } from '../helpers/getAppConfigSlug';

import { getStory } from './getStory';

import type {
  AppConfigStoryblok,
  DataSourceEntry,
  Locales,
} from '@monoimin/sb-types';

const prepareCategories = (pageType: string) => (arr: DataSourceEntry[]) =>
  arr.map((c) => ({ ...c, value: c.value.replace(`${pageType}-`, ``) }));

/**
 *
 * @param page
 * @param locale
 * @param site - использовался ранее, когда эта функция фильтровала категории блога на основе AppConfig, сейчас это делает функция `getActualBlogCategories`
 */
export async function getPreparedCategories(
  page: 'blog' | 'insider' | 'case',
  locale: undefined | Locales = 'en',
  // eslint-disable-next-line
  site?: MiniSlug
): Promise<DataSourceEntry[]> {
  const data = await getCategoriesDatasource(locale);
  // в датасорсе хранятся категории всех проектов и всех их типов статей (блог, новости, кейсы), и в value каждый объект категории имеет префикс {project}-{type}, например, imin-blog | golden-visa-guides
  const pageType = `imin-${page}`;
  const filteredByType = data.filter((c) => c.type === pageType);

  const prepareCategoriesCb = prepareCategories(pageType);

  return prepareCategoriesCb(filteredByType);
}

export async function getActualBlogCategories(
  locale: undefined | Locales = 'en',
  site?: MiniSlug
): Promise<DataSourceEntry[]> {
  const categories = await getPreparedCategories('blog', locale, site);

  const configSlug = getAppConfigSlug(site);

  const {
    data: { story: config },
  } = await getStory<AppConfigStoryblok>(configSlug, {
    language: locale,
    version: 'published',
  });

  const pageType = `imin-blog`;
  const res = categories.filter((c) =>
    config?.content.blogCategories?.includes(`${pageType}-${c.value}`)
  );

  return res;
}
